import React from 'react';
import { Box, TextField, Button, Typography, FormControl, Select, InputLabel } from '@mui/material';

//const DisabledTextField = ({ v }) => <TextField fullWidth size='small' disabled sx={{ mb: 2, backgroundColor: "#fff" }} label={v}/>;
// const DisabledSelect = ({ label, value }) => (
//     <FormControl fullWidth sx={{ mt: 1 }}>
//         <FormLabel sx={{ fontSize: 14 }}>{label}</FormLabel>
//         <Select size='small' disabled backgroundColor="#fff">
//         </Select>
//     </FormControl>
// );

export const BeOurAgent = () => (
    <Box height="80%" className="overflowY">
        <Box p={2} mb={4}>
            <Typography variant="h6" sx={{ mb: "0.5rem" }} fontWeight={550}>Be our Agent</Typography>
            {['Last Name', 'First Name', 'Mobile Number', 'Email'].map((v, i) => <TextField key={i} size='small' fullWidth label={v} required disabled InputLabelProps={{ sx: { '& .MuiFormLabel-asterisk': { color: 'error.main', }, }, }} sx={{ '& .MuiInputBase-root': { backgroundColor: '#ffffff' }, mb: "1rem" }}/>)}
            <Typography variant="subtitle1" fontWeight={550}>Address</Typography>
            {['Province', 'City', 'Barangay'].map((v, i) => (
                <Box mt="0.5rem" key={i}>
                    <Typography variant="body1" color="text.primary" sx={{ fontSize: "0.875rem", fontWeight: "700", marginBottom: "0.5rem", }}>{v}<Typography component="span" color="error"> * </Typography></Typography>
                    <FormControl fullWidth size="small" disabled>
                        <InputLabel id={`${v}-label`}>Select {v}</InputLabel>
                        <Select labelId={`${v}-label`} size='small' disabled label={`Select ${v}`} sx={{ backgroundColor: "#ffffff", }} value=""></Select>
                    </FormControl>
                </Box>
            ))}
            <Box mt="0.5rem">
                <Typography variant="body1" color="text.primary" sx={{ fontSize: "0.875rem", fontWeight: "700", marginBottom: "0.5rem", }}>Street Number</Typography>
                <TextField size='small' fullWidth disabled label="Input Street Number" sx={{ '& .MuiInputBase-root': { backgroundColor: '#ffffff' }, backgroundColor: "#ffffff" }}/>
            </Box>
            <Box mt="0.5rem">
                <Typography variant="body1" color="text.primary" sx={{ fontSize: "0.875rem", fontWeight: "700", marginBottom: "0.5rem", }}>Message<Typography component="span" color="error"> * </Typography></Typography>
                <TextField size='small' fullWidth disabled label="Composed Message" sx={{ '& .MuiInputBase-root': { backgroundColor: '#ffffff' }, backgroundColor: "#ffffff" }}
                    inputProps={{ 
                        style: {
                            height: "8rem"
                        }
                    }} 
                    InputLabelProps={{
                        sx: { fontStyle: "italic" },
                    }}
                />
            </Box>
            <Box display="flex" justifyContent="center">
                <Button variant="contained" color="primary" disabled sx={{ mt: "1rem" }}>
                    Submit
                </Button>
            </Box>
        </Box>
    </Box>
);